<template>
	<bsh-modal 
		titulo="Adicionar material"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <material-form
				:dados="dados"
				:name="name"
				:errors="errors">
			</material-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import ProdutoMaterial from "./../../../models/ProdutoMaterial.js";
	export default {
		data(){
			return {
				dados: new ProdutoMaterial(),
				name: 'create_produto_material',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
				this.dados['produto_id'] = this.$route.params.id;
	            axios.post(this.$url+'/api/adm/produto-materiais/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new ProdutoMaterial()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>